import { z } from 'zod';

// ─── Allowed role codes (whitelist — matches system 4 roles + common customs) ─
const SYSTEM_ROLES = ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER', 'ROLE_GUEST'] as const;

/**
 * Simulator form schema.
 * The user selects one radio option from the 4 system roles.
 * Direct URL manipulation with unknown codes is caught server-side (400) and
 * surfaced as ErrorState; the FE schema validates only the radio form.
 */
export const simulatorFormSchema = z.object({
  selectedRole: z
    .enum(SYSTEM_ROLES, {
      errorMap: () => ({ message: '유효한 역할을 선택해 주세요' }),
    })
    .default('ROLE_USER'),
});

export type SimulatorFormValues = z.infer<typeof simulatorFormSchema>;

// ─── Response schemas (runtime parse for safety) ─────────────────────────────

export const endpointPredictionSchema = z.object({
  path: z.string(),
  expectedStatus: z.union([z.literal(200), z.literal(403)]),
  reason: z.string(),
});

export const simulateResponseSchema = z.object({
  assumedRoles: z.array(z.string()),
  computedPermissions: z.array(z.string()),
  endpointPredictions: z.array(endpointPredictionSchema),
});

export const matrixCellSchema = z.object({
  role: z.string(),
  permission: z.string(),
  granted: z.boolean(),
  systemRole: z.boolean(),
});

export const matrixResponseSchema = z.object({
  roles: z.array(z.string()),
  permissions: z.array(z.string()),
  cells: z.array(matrixCellSchema),
});

export const myPermissionsResponseSchema = z.object({
  userId: z.number(),
  userName: z.string(),
  roles: z.array(z.string()),
  permissions: z.array(z.string()),
  rolesCount: z.number(),
  permissionsCount: z.number(),
  evaluatedAt: z.string(),
});

export const demoEndpointResponseSchema = z.object({
  endpoint: z.string(),
  requiredPermission: z.string(),
  message: z.string(),
  calledBy: z.string(),
  callerRoles: z.array(z.string()),
  calledAt: z.string(),
});
